import { antdLocales } from '@/i18n/translations/messages';

const allLocales = [
	{ label: 'English', value: 'en', abbr: 'EN', direction: 'ltr' },
	{ label: 'Русский', value: 'ru', abbr: 'РУ', direction: 'ltr' },
	{ label: 'עברית (beta)', value: 'he', abbr: 'עב', direction: 'rtl' },
	{ label: 'العربية (beta)', value: 'ar', abbr: 'عر', direction: 'rtl' },
	{ label: 'Italiano (beta)', value: 'it', abbr: 'IT', direction: 'ltr' },
]

const localeSettings = allLocales.filter(locale => antdLocales[locale.value] != null).map(locale => ({
	...locale,
	antdLocale: antdLocales[locale.value],
}));


const getLocaleData = locale => {
	const localeData = localeSettings.find(item => item.value === locale);
	if (!localeData) {
		return getLocaleData('en');
	}
	return localeData;
}

export {
	localeSettings,
	getLocaleData,
};
